module.exports = __webpack_public_path__ + "img/zb1.4c20eee0.png";